var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 122 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M109.4 108.519c-11.071 5.787-24.137 7.582-37.004 3.592-1.895-.499-3.79-1.397-5.485-2.195-7.182-3.492-12.368-8.579-13.665-9.976 12.767-.898 28.127-5.287 41.991-16.76 2.494-2.095 4.887-4.39 6.882-6.784l3.691 12.171 4.987 16.66c.798 1.996.299 2.395-1.397 3.292Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "evenodd",
    d: "M29.895 59.137c.798-7.482 3.391-14.366 7.182-20.451L26.704 3.969c-.599-1.995-2.195-1.596-2.594-1.397-.1 0-.199.1-.299.2-.399.3-12.268 11.772-16.357 18.855C1.17 32.9-5.014 70.41 35.58 86.57c-4.688-7.881-6.882-17.458-5.686-27.434Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M63.71.575C30.796 5.065 8.753 37.387 16.034 66.018c6.982 28.83 48.175 37.41 75.304 19.952-15.56 9.278-35.408 5.886-42.689-9.477-6.682-14.166.898-31.824 15.46-40.603 5.486-3.292 11.67-5.188 18.053-5.287 26.631-.3 36.506 29.33 17.156 49.182 7.979-7.482 13.963-17.16 16.058-28.133C121.26 21.624 96.824-4.214 63.71.575Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M97.329 17.433c-3.69-1.396-7.68-2.294-11.77-2.793-27.229-2.893-52.762 17.558-55.655 44.593-.499 4.59-.399 9.178.499 13.468 4.688 24.84 30.92 41.7 53.361 31.824 19.549-8.68 34.81-26.836 37.802-48.484 1.995-15.263-5.685-31.524-24.237-38.607Zm11.769 43.396c-3.092 19.454-24.237 34.318-43.786 29.33-13.066-3.392-20.946-15.463-18.752-29.33 2.694-17.458 20.148-31.225 37.902-30.227 16.358.997 27.13 14.266 24.636 30.227Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillRule: "evenodd",
    d: "M91.343 76.79C77.778 88.961 55.336 95.246 38.779 92.951c-14.861-1.995-25.035-8.679-31.418-17.557l-.1-.1C-4.41 58.933-3.91 25.613 22.92 3.666c.199-.2.997-.798.997-.798C17.435 8.752-1.815 34.89 8.857 55.94c6.982 13.967 23.24 18.955 38.999 17.658 12.767-.898 23.838-5.986 32.216-13.268.1 0 .1-.1.2-.1C105.704 38.682 106.004 3.965 73.489.074c.997 0 3.69 0 8.677.998 5.686 1.097 13.864 5.586 17.854 9.677 15.56 15.463 13.964 45.89-8.677 66.041Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillRule: "evenodd",
    d: "M99.528 82.679c-21.245 20.65-50.669 23.942-72.811 16.46C15.845 95.448 6.669 89.263.984 81.282c-.3-.499-1.696-2.295.798-3.392l6.982-3.192c.897-.5 1.396-.699 2.892.598 9.176 8.58 21.943 12.57 34.61 12.27 53.66-1.396 77.3-58.36 49.472-79.907-4.09-3.293-10.473-5.687-13.665-6.684l.499.1c7.58 1.496 14.363 4.489 20.048 8.679 21.943 18.455 17.255 53.072-3.092 72.925Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillRule: "evenodd",
    d: "M102.614 9.853c-1.895-1.397-3.79-2.594-5.785-3.591 7.281 4.788 11.67 10.574 14.263 15.363 9.475 16.96 4.987 39.006-8.777 54.769-2.194 2.394-4.39 4.688-6.883 6.783C81.568 94.75 66.21 99.04 53.442 99.937c-4.09.299-8.08.2-11.47-.1-1.796-.2-2.694.798-3.093 1.197l-3.89 4.29c-1.695 1.995-.897 3.192.699 3.591 10.373 2.694 21.145 2.794 31.219.799 7.081-1.397 13.864-3.692 20.147-6.884 7.082-3.591 13.466-8.58 18.752-14.365 8.278-8.979 13.963-20.252 15.659-32.622 2.693-18.855-4.987-35.814-18.851-45.99Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 109.849,
    x2: 74.772,
    y1: 95.268,
    y2: 95.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8669F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A3378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 19.56,
    x2: 35.859,
    y1: 59.114,
    y2: 16.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#724FD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#7A51D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#9055CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE5BC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 28.028,
    x2: 99.192,
    y1: 74.086,
    y2: 24.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#8669F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#4A3378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 39.313,
    x2: 107.365,
    y1: 84.575,
    y2: 36.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#907FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F419A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 18.071,
    x2: 89.466,
    y1: 79.088,
    y2: 7.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9689F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#BA82DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#E579C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#F576BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#F569AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F569AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 22.854,
    x2: 111.872,
    y1: 99.342,
    y2: 24.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E64DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A159EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#E959A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F55196"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 36.776,
    x2: 116.919,
    y1: 93.567,
    y2: 37.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F55C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#905DD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#9A59CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#B64EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#E03D8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#E03D8C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.7fe830df2d205c722e1c0dac6ec57439.svg";
export { ForwardRef as ReactComponent };